import { isLiveEligible } from "@/lib/decisionGraph";

// Shareable Snapshot links: run_id + ledger sequence, nothing else. The link is a
// deep link INTO the authorized Decision Graph view — it carries no token, no PII,
// no payload — so opening it goes through the same canonical read authorization
// as navigating there directly.
export const SNAPSHOT_BASE = "/app/decision-graph/snapshot";

export function buildSnapshotPath(runId, sequence) {
  if (!runId || typeof sequence !== "number" || !Number.isInteger(sequence) || sequence < 0) return null;
  return `${SNAPSHOT_BASE}/${encodeURIComponent(runId)}/${sequence}`;
}

export function parseSnapshotParams(params) {
  const runId = params?.runId ? decodeURIComponent(params.runId) : null;
  const seq = params?.seq != null && /^\d+$/.test(String(params.seq)) ? Number(params.seq) : null;
  if (!runId || seq === null) return null;
  return { runId, sequence: seq };
}

// Index of the frame at (or the last frame before) the requested sequence.
export function frameIndexForSequence(events, sequence) {
  if (!events?.length) return 0;
  let idx = -1;
  events.forEach((e, i) => { if (e.sequence <= sequence) idx = i; });
  return Math.max(0, idx);
}

// What to tell the viewer about the frame they opened.
//  live_continued — the Run is still running; this frame is NOT the current state.
//  frame_missing  — the requested sequence is not (yet) on the record.
export function snapshotNotice({ runStatus, events, sequence }) {
  if (isLiveEligible(runStatus)) return "live_continued";
  const exact = (events || []).some((e) => e.sequence === sequence);
  if (!exact) return "frame_missing";
  return null;
}

// The classification travels with the link: a demo Run stays marked demo.
export function runClassification(recon) {
  return recon?.run?.contract?.request?.data_classification
    || recon?.task?.data_classification || null;
}

// Legend version is ALWAYS the one stamped on the Run at creation (never the live legend).
export function snapshotLegendVersion(recon) {
  return recon?.run?.contract?.configuration?.legend_version || recon?.run?.summary?.legend_version || 1;
}
